module.exports = __webpack_public_path__ + "static/img/产品中心-井下智能防爆终端-实时声光报警.f7243ab6.png";